import { Injectable, NgZone } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';
import { LocalStorageService } from '../local-storage.service';
import { Observable, Subscriber } from 'rxjs';
import { Router } from '@angular/router';

// setTimeout no admite esperas mayores a ~24.8 días
const MAX_TIMEOUT = 2147483647;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private token:string;
  private url = environment.apiURL;
  private obsIsLoggedIn: Observable<boolean>;
  private subscriberIsLoggedIn: Subscriber<boolean> | undefined;
  user : any;
  // Se cerró la sesión porque venció el token: el login lo avisa
  sessionExpired = false;
  private sessionTimer?: ReturnType<typeof setTimeout>;
  
  constructor(
    public router: Router,
    private _http: HttpClienteService,
    private _localStorageService: LocalStorageService,
    private readonly ngZone: NgZone
  ) { 
    this.token = this.getToken();
    this.scheduleSessionExpiry();
  }

  subscribeIsLoggedIn(): Observable<boolean>{
    return this.obsIsLoggedIn
  }

  pushIsLoggedIn(): void{
    this.subscriberIsLoggedIn && this.subscriberIsLoggedIn.next(this.isLoggedIn());
  }


  
  getToken(): string {
    const token = this.getUser() ?
    (this.getUser().token && this.getUser().token != "" ? this.getUser().token: {} ) : {};
    return token
  }

  getUser() {
    const user = this._localStorageService.getItem('user');
   if(user){
    return Object.keys(user).length !== 0 ? user: null;
   }
  }

  setUser(obj: any) {
    this._localStorageService.setItem('user', obj);
    this.token = this.getToken();
    if(this.token) this.pushIsLoggedIn();
    this.user = this.getUser();
    this.sessionExpired = false;
    this.scheduleSessionExpiry();
  }
  logout() {
    clearTimeout(this.sessionTimer);
    this._localStorageService.cleanStore();
    this.pushIsLoggedIn();
    this.router.navigate(['/login']);
  }

  // Token vencido: se cierra la sesión para que el usuario vuelva a ingresar y obtenga uno nuevo
  expireSession() {
    if (!this.getUser()) return;
    this.sessionExpired = true;
    this.logout();
  }

  // Vencimiento del token (claim exp del JWT) en milisegundos; null si no se puede leer
  getTokenExpiration(): number | null {
    const token = this.getToken();
    if (typeof token !== 'string') return null;
    try {
      const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      return payload.exp ? payload.exp * 1000 : null;
    } catch {
      return null;
    }
  }

  isTokenExpired(): boolean {
    const expiration = this.getTokenExpiration();
    return expiration !== null && Date.now() >= expiration;
  }

  // Cierra la sesión en el momento en que vence el token, aunque el usuario no haga nada.
  // El timer corre fuera de Angular para no dejar la app "inestable" durante horas.
  private scheduleSessionExpiry() {
    clearTimeout(this.sessionTimer);
    const expiration = this.getTokenExpiration();
    if (expiration === null) return;
    const delay = Math.min(Math.max(expiration - Date.now(), 0), MAX_TIMEOUT);
    this.ngZone.runOutsideAngular(() => {
      this.sessionTimer = setTimeout(() => {
        if (this.isTokenExpired()) this.ngZone.run(() => this.expireSession());
        else this.scheduleSessionExpiry();
      }, delay);
    });
  }

  login(data: any){
    const query = `${this.url}/wcl-authentication/bo-login`;
    return this._http.post(query, data);
  }
  
  getInformation(){
    const query = `${this.url}/wcl-customer/bo-enum`;
    return this._http.get(query);
  }
  
  isLoggedIn(): boolean {
    const token = this.getToken();
    return Object.keys(token).length !== 0 && !this.isTokenExpired();
  }
}
